'use client';
import { replaceToSiblingTimezoneName } from './replaceToSiblingTimezoneName';

/**
 * Gets the user's timezone - browser only function
 * @returns {string} IANA timezone string (e.g. "America/New_York")
 * @example
 * const timezone = getTimezoneName(); // "Europe/London"
 */
export const getTimezoneName = (): string => {
  const tzName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return replaceToSiblingTimezoneName(tzName);
};
